import { JSXElementConstructor, ReactElement, type JSX } from 'react'
import { Route } from 'react-router-dom'

import { Navigate } from '@lib/react-router-dom'

import { useDocumentVerificationPath } from '@hooks/useDocumentVerificationPath'
import { LayoutDefinition } from '@hooks/useLayoutVariant'

export interface RouteConfig<T = string> {
  path?: T | string
  element?: JSX.Element
  condition?: boolean
  layout?: LayoutDefinition
  outlet?: JSX.Element
  locked?: boolean
  children?: RouteConfig<T>[]
  meta?: {
    breadcrumbLabel: string
    hideChildrenBreadcrumbs?: boolean
  }
}

export const useRenderRoutes = (): ((
  routes: RouteConfig<string>[]
) => ReactElement<any, string | JSXElementConstructor<any>>) => {
  const docVerificationPath = useDocumentVerificationPath()

  const renderRoutes = (routes: RouteConfig<string>[]) => (
    <>
      {routes
        .filter((route) => route.condition !== false)
        .map(({ children, path, element, locked, outlet }, index) => {
          if (locked) {
            return (
              <Route
                key={`${path}-${index}`}
                path={path}
                element={<Navigate to={docVerificationPath} />}
              />
            )
          }
          if (children) {
            return (
              <Route key={`${path}-${index}`} path={path} element={outlet}>
                {renderRoutes(children)}
                <Route index element={element} />
              </Route>
            )
          }
          return <Route key={`${path}-${index}`} index={!path} path={path} element={element} />
        })}
    </>
  )

  return renderRoutes
}
